import React, { useState } from 'react';

import LocalText from '@/localization/local_text';
import './css/common_program_search.scss';

function CommonProgramSearch({ mode, boardRefetch, boardData, setListData, type }) {
  const [keyword, setKeyword] = useState('titleContent');
  const [word, setWord] = useState('');

  return (
    <form id="CommonProgramSearch" className="searchForm">
      <label className="sr-only" htmlFor="searchOption">
        Choose search option
      </label>
      <input type="search" id="none" />
      <select id="searchOption" className="searchOption" onChange={(e) => setKeyword(e.target.value)}>
        <option value="titleContent">{mode === 'ko' ? '전체' : 'All'}</option>
        <option value="title">{mode === 'ko' ? '제목' : 'Title'}</option>
      </select>
      <label htmlFor="totalSearch" className="sr-only">
        full search
      </label>
      <input
        type="search"
        name="totalSearch"
        id="totalSearch"
        className="inputSearch"
        placeholder={mode === 'ko' ? '검색어를 입력하세요.' : 'Enter a search word'}
        onChange={(e) => setWord(e.target.value)}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            setListData([]);
            boardRefetch({
              ...boardData,
              key_word: keyword,
              word: word,
              type: type === 'vod' ? 'vod' : type === 'aod' ? 'aod' : null,
            });
          }
        }}
      />
      <button
        type="button"
        className="btnSearch"
        onClick={() => {
          setListData([]);
          boardRefetch({
            ...boardData,
            key_word: keyword.toString(),
            word: word,
            type: type === 'vod' ? 'vod' : type === 'aod' ? 'aod' : null,
          });
        }}
      >
        <LocalText txt={'common_search_btn'} />
      </button>
    </form>
  );
}

export default CommonProgramSearch;
